import { Component } from '@angular/core';

@Component({
  selector: 'app-required-marker',
  imports: [],
  templateUrl: './required-marker.component.html',
  styleUrl: './required-marker.component.css',
})
export class RequiredMarkerComponent {
}
